import type { AudioState } from './AudioState';
import type { CompositionState } from './CompositionState';
import type { TextState } from './TextState';
import type { VideoState } from './VideoState';

export interface ElementState
  extends CompositionState, TextState, VideoState, AudioState {
  /**
   * This element's track number.
   */
  track: number;

  /**
   * This element's appearance time in relation to its composition.
   */
  localTime: number;

  /**
   * This element's appearance time in relation to the entire video.
   */
  globalTime: number;

  /**
   * This element's duration in seconds.
   */
  duration: number;

  /**
   * Exit transition duration in seconds, i.e. how long the next element overlaps it.
   */
  exitDuration: number;

  /**
   * The time in seconds when the element should start fading in.
   */
  trimStart: number;

  /**
   * The source JSON of the element without the 'elements' property.
   */
  source: Record<string, any>;
}

function toFiniteNumber(value: unknown): number {
  const parsed =
    typeof value === 'number' ? value : Number.parseFloat(String(value));
  return Number.isFinite(parsed) ? parsed : 0;
}

export function mapToElementState(el: Record<string, any>): ElementState {
  const time = toFiniteNumber(el.time);
  return {
    source: {
      ...el,
      elements: undefined,
    },
    elements: el.elements?.map(mapToElementState),
    duration: toFiniteNumber(el.duration),
    globalTime: time,
    localTime: time,
    trimStart: toFiniteNumber(el.trim_start),
    track: el.track,
    exitDuration: 0,
  };
}
